import sanitizeHtml, { IOptions } from "sanitize-html";

const defaultOptions = {
  allowedTags: ["a", "p", "h1", "h2", "h3", "h4", "h5", "h6", "div", "strong", "ul", "li", "em", "br"],
  allowedAttributes: {
    a: ["href"],
  },
  allowedIframeHostnames: ["www.youtube.com"],
};

const sanitize = (dirty: string, options?: IOptions) => ({
  __html: sanitizeHtml(dirty, { ...defaultOptions, ...options }),
});

interface Props {
  html: string;
  options?: IOptions;
}

// We disable react/no-danger because we fix the dangers.
// eslint-disable-next-line react/no-danger
const SanitizeHTML: React.FC<Props> = ({ html, options }) => <div dangerouslySetInnerHTML={sanitize(html, options)} />;

export default SanitizeHTML;
